/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Add_Font_DescInputs */



/**
* | output |
* | --- |
* | "Add system fonts to use in your captions and subtitles" |
*
* @param {Options_Fonts_Add_Font_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_add_font_desc = /** @type {((inputs?: Options_Fonts_Add_Font_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Add_Font_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter des polices système à utiliser dans vos sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie Systemschriftarten hinzu, die Sie in Ihren Untertiteln verwenden möchten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi i font di sistema da utilizzare nei sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавьте системные шрифты для использования в субтитрах и подписях.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregue fuentes del sistema para usar en sus subtítulos y leyendas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加系统字体以用于字幕和副标题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションや字幕に使用するシステムフォントを追加する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने कैप्शन और सबटाइटल में उपयोग करने के लिए सिस्टम फ़ॉन्ट जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicione fontes do sistema para usar em suas legendas e subtítulos.")
	return /** @type {LocalizedString} */ ("Add system fonts to use in your captions and subtitles")
});